module.exports = __webpack_public_path__ + "img/zuijia_04.2079c858.png";